import React, { useEffect, useRef, useState } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Axios from 'axios'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import equals from '../../assets/equals.svg'
import minus from '../../assets/minus.svg'
import multiplication from '../../assets/multiplication.svg'
import { toast } from 'react-toastify'
import Globe from 'react-globe.gl'
import { devURL, isEarlyBird } from '../../utils'
import { sendAnalyticsEvent } from '../../analytics'

const inputStyles = {
  appearance: 'none',
  border: 0,
  outline: 0,
  font: 'inherit',
  padding: '0 2em 0 1em',
  background:
    'url(https://upload.wikimedia.org/wikipedia/commons/9/9d/Caret_down_font_awesome_whitevariation.svg) no-repeat right 0.4em center/0.7em, linear-gradient(to left, rgba(255, 255, 255, 0.3) 1.4em, rgba(255, 255, 255, 0.2) 1em)',
  borderRadius: '0.25em',
  color: 'white',
  fontWeight: '500',
  fontSize: '1.125rem',
  lineHeight: '1.75rem',
}
const currencies = {
  eur: {
    symbol: 'EUR',
    flag: '/images/europe.png',
    alt: 'europe',
  },
  inr: {
    symbol: 'INR',
    flag: '/images/india.png',
    alt: 'India',
  },
}

export default function SendMoneyCard({ setAmout, setRate }) {
  const navigate = useNavigate()
  const globeEl = useRef()
  const toAddTransaction = () => {
    navigate('/AddTransaction', { state: { input } })
  }
  const [oneEuroInr, setEuroToInr] = useState(0)
  const [input, setInput] = useState(1000)
  const [output, setOutput] = useState(0)
  const [sendCurrency, setCurrency] = useState('eur')
  const [receiveCurrency, setReceiveCurrency] = useState('inr')

  useEffect(() => {
    AOS.init()
  }, [])

  useEffect(() => {
    const globe = globeEl.current

    // Auto-rotate
    globe.controls().autoRotate = true
    globe.controls().autoRotateSpeed = 0.65
  }, [])

  const handelEURChange = (e) => {
    if (e.target.value <= 15000) {
      setInput(e.target.value)
      setAmout(e.target.value)
      setOutput((e.target.value * oneEuroInr).toFixed(2))
    } else {
      return toast.error('The most you can send is 15,000 EUR.')
    }
  }

  const handelINRChange = (e) => {
    let eur = e.target.value / oneEuroInr
    if (eur <= 15000) {
      setInput(eur.toFixed(2))
      setAmout(eur)
      setOutput(e.target.value)
    } else {
      return toast.error('The most you can send is 15,000 EUR.')
    }
  }

  useEffect(() => {
    Axios.get(`${devURL}/user/getRate`)
      .then((response) => {
        setEuroToInr(response.data.rate)
        setRate(response.data.rate)
        setInput(1000)
        setOutput((1000 * response.data.rate).toFixed(2))
      })
      .catch((error) => {
        console.log('error ' + error)
      })
  }, [])

  const arcsData = [
    {
      startLat: 28.6139,
      startLng: 77.209,
      endLat: 51.1657,
      endLng: 10.4515,
      color: '#246eaa',
    },
    {
      startLat: 35.6895,
      startLng: 139.6917,
      endLat: 37.7749,
      endLng: -122.4194,
      color: '#246eaa',
    },
    {
      startLat: -33.8688,
      startLng: 151.2093,
      endLat: 51.5074,
      endLng: -0.1278,
      color: '#246eaa',
    },
    {
      startLat: -22.9068,
      startLng: -43.1729,
      endLat: 9.1021,
      endLng: 18.2812,
      color: '#246eaa',
    },
    {
      startLat: 37.5665,
      startLng: 126.978,
      endLat: 55.7558,
      endLng: 37.6173,
      color: '#246eaa',
    },
    // add more objects here if needed
  ]

  return (
    <div className='relative 2xl:block xl:block lg:block md:block lg:pt-20 pt-16 pb-10 2xl:h-screen xl:h-screen lg:h-screen md:h-screen md:bg-transparent'>
      <div className='relative'>
        <div className='min-h-full max-w-screen-xl mx-auto sm:flex justify-between px-6'>
          <span className='font-nunito'>
            <div className='relative 2xl:max-w-full xl:max-w-full lg:max-w-md md:max-w-sm sm:max-w-xs sm:my-0 my-5'>
              <div className='max-w-2xl sm:-mt-10 lg:mt-16 text-center'>
                <h1 className='font-extrabold mt-32 2xl:text-4xl xl:text-4xl lg:text-4xl md:text-2xl sm:text-xl text-3xl'>
                  Now, send money at real exchange rate!
                </h1>
                <br />
                <h2 className='font-light 2xl:text-2xl xl:text-4xl lg:text-4xl md:text-2xl sm:text-2xl text-2xl'>
                  Say NO to money transfer fees.
                </h2>
                <div className='max-w-2xl  text-gray-600 text-2xl xs:text-sm'>
                  <div className=' justify-center hidden sm:flex mt-4'>
                    <Globe
                      width={320}
                      ref={globeEl}
                      animateIn={true}
                      height={280}
                      backgroundColor='#ffffff'
                      globeImageUrl='//unpkg.com/three-globe/example/img/earth-day.jpg'
                      bumpImageUrl='//unpkg.com/three-globe/example/img/earth-topology.png'
                      arcsData={arcsData}
                      arcAltitude={0.45}
                      arcDashInitialGap={0.3}
                      arcColor={'color'}
                      arcStroke={4}
                      arcsTransitionDuration={8000}
                      arcDashLength={() => 0.8}
                      arcDashGap={() => 0.8}
                      arcDashAnimateTime={() => 0.5 * 4000 + 500}
                    />
                  </div>

                  <div
                    className='text-center my-14 lg:mt-10 lg:my-0'
                    data-aos='fade-up'
                    data-aos-anchor='#example-anchor'
                    data-aos-offset='500'
                    data-aos-duration='500'
                  >
                    <Link
                      to={isEarlyBird ? '/EarlyBird' : '/SignUp'}
                      className='bg-themeColor hover:bg-themeHover text-[white] font-medium md:font-semibold px-4 py-2  rounded-md text-md sm:text-2xl '
                    >
                      Open account
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </span>

          <div
            data-aos='fade-left'
            data-aos-anchor='#example-anchor'
            data-aos-offset='500'
            data-aos-duration='500'
            className='2xl:justify-end mt-16 xl:justify-end lg:justify-end md:justify-end justify-end 2xl:max-w-md xl:max-w-md lg:max-w-md md:max-w-sm w-full 2xl:mx-0 xl:mx-0 lg:mx-0 md:mx-0 sm:mx-0  bg-white p-4 shadow-lg rounded-xl border-2 space-y-8'
          >
            {/* <form className="mt-8 space-y-6" action="#" method="POST"> */}

            <input type='hidden' name='remember' defaultValue='true' />
            <div className='rounded-md shadow-sm space-y-4'>
              <div className='border-2 ht-16 flex flex-row justify-between -mt-6 md:-mt-0'>
                <label
                  htmlFor='send'
                  className='flex-col  block relative text-md mt-1 font-medium text-gray-700 ht-16 '
                >
                  <span className='pl-3 text-lg'>Transfer amount</span>
                  <div className='mt-1 rounded-md shadow-sm'>
                    <input
                      type='text'
                      min='0'
                      name='send'
                      id='send'
                      onKeyPress={(event) => {
                        if (!/[0-9.]/.test(event.key)) {
                          event.preventDefault()
                        }
                      }}
                      className='pl-3 text-lg focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 block w-full pr-4 sm:text-xl border-gray-300 rounded-none font-semibold'
                      placeholder='Enter Sending amount'
                      defaultValue={input}
                      value={input}
                      onChange={handelEURChange}
                    />
                  </div>
                </label>
                <div className='px-4 min-h-full flex flex-row items-center bg-themeColor max-w-xs'>
                  <label htmlFor='send-currency' className='sr-only'>
                    Currency
                  </label>
                  <img
                    className='h-6 pr-2 hidden lg:flex'
                    src={currencies[sendCurrency].flag}
                    alt={currencies[sendCurrency].alt}
                  />{' '}
                  <select
                    name='send-currency'
                    id='send-currency'
                    style={inputStyles}
                    onChange={(e) => setCurrency(e.target.value)}
                    className='cursor-pointer'
                  >
                    <option
                      value='eur'
                      className='text-black font-medium'
                      selected
                    >
                      <p className='text-xs'>EUR</p>
                    </option>
                  </select>
                </div>
              </div>
              <div>
                <div className='px-10 '>
                  <ol className='relative border-l border-gray-200'>
                    <li className='ml-6'>
                      <h3 className=' text-lg font-light text-gray-900 h-4'>
                        <span className='text-white'>.</span>
                      </h3>
                    </li>
                    <li className='mb-4 lg:mb-10 ml-6'>
                      <span className='flex absolute -left-3 justify-center items-center w-6 h-6 bg-blue-200 rounded-full ring-8 ring-white'>
                        <img
                          src={multiplication}
                          alt='multiplication'
                          className='w-3 h-3'
                        />
                        {/* <svg
                          className="w-3 h-3"
                          style={{ color: "#5c6e64" }}
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                            clipRule="evenodd"
                          ></path>
                        </svg> */}
                      </span>
                      <h3 className=' text-lg font-light text-gray-900 '>
                        Exchange rate:{' '}
                        <span className='font-medium'>
                          1 EUR ={' '}
                          <span data-test='get-rate'>
                            {oneEuroInr.toFixed(2)}
                          </span>{' '}
                          INR
                        </span>
                      </h3>
                      <p className='mb-4 text-base font-normal text-gray-500'>
                        Live from Yahoo Finance
                      </p>
                    </li>
                    <li className='mb-6 md:mb-10 ml-6 flex'>
                      <span className='flex absolute -left-3 justify-center items-center w-6 h-6 bg-blue-200 rounded-full ring-8 ring-white'>
                        <img src={minus} alt='fees' className='w-3 h-3' />
                        {/* <svg
                          className="w-3 h-3"
                          style={{ color: "#5c6e64" }}
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                            clipRule="evenodd"
                          ></path>
                        </svg> */}
                      </span>
                      <h3 className='mb-1 text-lg font-normal text-gray-900'>
                        Fees:{' '}
                        <span className='line-through decoration-1.5 decoration-themeColor pr-1'>
                          1 EUR
                        </span>{' '}
                        <span className='font-semibold font-xl text-themeColor'>
                          OFFER!
                        </span>
                      </h3>
                    </li>
                    <li className='mb-10 ml-6 hidden md:flex'>
                      <span className='flex absolute -left-3 justify-center items-center w-6 h-6 bg-blue-200 rounded-full ring-8 ring-white '>
                        <img src={equals} alt='equals' className='w-3 h-3 ' />
                      </span>
                      <h3 className='mb-1 text-lg font-normal text-gray-900 hidden md:flex'>
                        Guaranteed rate for the next 24 hrs
                      </h3>
                    </li>
                    <li className='ml-6 h-1 hidden md:flex'>
                      <h3 className='mb-1 text-lg font-light text-gray-900 '>
                        <span className='text-white'>.</span>
                      </h3>
                    </li>
                  </ol>
                </div>
              </div>
              <div className='border-2 ht-16 flex flex-row justify-between'>
                <label
                  htmlFor='receive'
                  className='flex-col text-md mt-1 font-medium text-gray-700 ht-16'
                >
                  <span className='pl-3 text-lg'>Amount received</span>
                  <div className='mt-1 rounded-md shadow-sm min-w-full'>
                    <input
                      type='text'
                      min='0'
                      name='receive'
                      id='receive'
                      className='pl-3 text-lg focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 block w-full pr-4 sm:text-xl border-gray-300 rounded-md font-semibold'
                      placeholder='Receiving amount'
                      value={output ? output : ''}
                      onChange={handelINRChange}
                    />
                  </div>
                </label>
                <div className='px-4 min-h-full flex flex-row items-center bg-themeColor'>
                  <label htmlFor='send-currency' className='sr-only'>
                    Currency
                  </label>
                  <img
                    className='h-8 pr-2 hidden lg:flex'
                    src={currencies[receiveCurrency].flag}
                    alt={currencies[receiveCurrency].alt}
                  />{' '}
                  <select
                    name='send-currency'
                    id='send-currency'
                    style={inputStyles}
                    onChange={(e) => setReceiveCurrency(e.target.value)}
                    className='cursor-pointer'
                  >
                    <option
                      value='inr'
                      className='text-black font-medium text-lg'
                      selected
                    >
                      INR
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className='mb-40'>
              <Link
                to={isEarlyBird ? '/EarlyBird' : '/Login'}
                state={input}
                className='group relative w-full flex justify-center py-5 px-4 border border-transparent text-xl rounded-md text-white font-bold bg-themeColor hover:bg-themeHover'
                // onClick={Convert}
                onClick={() => {
                  sendAnalyticsEvent('click', {
                    category: 'Send Money',
                    action: 'click',
                    label: 'home page card',
                  })
                }}
              >
                Send Money Now
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  )
}
